import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { cloneElement } from "react";

const Sortable = ({ children, id }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children &&
        cloneElement(children, {
          dndProperties: { ...listeners, ...attributes },
        })}
    </div>
  );
};

export default Sortable;
